export function calculateHours(fromDateTime, toDateTime) {
  if (!fromDateTime || !toDateTime) return 0;
  const from = new Date(fromDateTime);
  const to = new Date(toDateTime);
  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return 0;
  const diffMs = to.getTime() - from.getTime();
  if (diffMs <= 0) return 0;
  return diffMs / (1000 * 60 * 60);
}
